<script setup lang="ts">
import clsx from 'clsx';

const props = defineProps<{ class?: string }>();
const classes = clsx(
  'flex flex-1 flex-col overflow-y-auto p-4',
  '[&>[data-slot=section]+[data-slot=section]]:mt-8',
  props.class,
);
</script>

<template>
  <div :class="classes"><slot /></div>
</template>
